import { MenuItem } from '../state/cart/cartTypes';

export const MENU: MenuItem[] = [];

export const CATEGORIES = Array.from(new Set(MENU.map((m) => m.category)));

